import * as DialogPrimitive from "@radix-ui/react-dialog";
import { DialogContent } from "./DialogContent";
import { DialogHeader } from "./DialogHeader";
import { DialogTitle } from "./DialogTitle";
import { DialogDescription } from "./DialogDescription";
import { DialogFooter } from "./DialogFooter";
import { DialogChildren } from "./DialogChildren";
import { FC } from "react";
import { DIALOG_ROOT_DEFAULTS, TDialogRootProps } from "./Dialog.config";


export const Dialog: FC<TDialogRootProps> = ({
  title,
  description,
  children,
  footer,
  header,
  "data-component": component = DIALOG_ROOT_DEFAULTS["data-component"],
  ...props
}) => (
  <DialogPrimitive.Root {...props}>
    <DialogContent data-component={component}>
      <DialogHeader {...header}>
        <DialogTitle>{ title }</DialogTitle>
        { description ? (
          <DialogDescription>
            { description }
          </DialogDescription>
        ): null }
      </DialogHeader>
      <DialogChildren>
        { children }
      </DialogChildren>
      <DialogFooter {...footer} />
    </DialogContent>
  </DialogPrimitive.Root>
);
